import { render, staticRenderFns } from "./BreakingNews.vue?vue&type=template&id=c332babc&scoped=true"
import script from "./BreakingNews.vue?vue&type=script&lang=js"
export * from "./BreakingNews.vue?vue&type=script&lang=js"
import style0 from "./BreakingNews.vue?vue&type=style&index=0&id=c332babc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c332babc",
  null
  
)

export default component.exports